export default __webpack_public_path__ + "static/media/netlify.156b9a66.png";